'use strict';

var util = require('../../util/property-util');
var arrayUtil = require('../../util/array-util');
var nocUtil = require('../../util/noc-util');

module.exports = /*@ngInject*/ ["TripDashboardFactory", function (TripDashboardFactory) {
    var factory = {};

    var stateDefinition = {
        orange: {
            icon: "fa-exclamation",
            class: "warn"
        },
        red: {
            icon: "fa-times",
            class: "danger"
        },
        green: {
            icon: "fa-check",
            class: "success"
        },
        grey: {
            icon: "fa-close",
            class: "invalid"
        }
    };

    factory.getTrainGrid = function (tripIds, callback) {
        getTrainGrid(tripIds, callback)
    };

    /**
     * Function posts array of trip ids to traingrid service.
     * Once received,uses callback to send a list of grid tiles.
     * Each grid tile will have it's color determined and list of slas that have not reached their target.
     * @param tripIds
     * @param callback
     */
    function getTrainGrid(tripIds, callback) {
        TripDashboardFactory.getGrid(tripIds).then(function (trains) {
            trains = trains.data;
            if (util.isDefined(trains)) {

                trains.sort(function (a, b) {
                    return arrayUtil.sortByPropertyASC('relativeTrainId', a, b);
                });

                trains.forEach(function (trainGridObject) {
                    trainGridObject.state = factory.defineState(trainGridObject);
                    trainGridObject.sqiStatus = factory.getMissedSQIs(trainGridObject);
                });

                callback(trains);
            }
        });
    }

    /**
     * Will return one state out of the stateDefinition object. These states are green,orange,red and grey.
     * The state is determined on the sla value and it's targets and tresholds. A value can be 'inverted' if lower means better.
     * @param trainSlaValue  projectId, relativeTrainId, slaResults [value,target,threshold,unit,name, inverted ]
     * @returns object that has icon and color property.
     */
    factory.defineState = function (trainSlaValue) {

        var state = angular.copy(stateDefinition['green']);

        var beyondTarget = 0;
        var beyondThreshold = 0;

        var tooltip = "";

        if (arrayUtil.isEmpty(trainSlaValue.slaResults)) {
            return angular.copy(stateDefinition['grey']);
        }

        trainSlaValue.slaResults.forEach(function (slaResult) {

            tooltip += slaResult.name + ": " + nocUtil.roundToTwo(slaResult.value) + "" + slaResult.unit + "\n";

            if (slaResult.inverted) {
                if (slaResult.value > slaResult.target) {

                    beyondTarget++;

                    if (slaResult.value > slaResult.threshold) {
                        beyondThreshold++;
                    }
                }
            } else {
                if (slaResult.value < slaResult.target) {

                    beyondTarget++;

                    if (slaResult.value < slaResult.threshold) {
                        beyondThreshold++;
                    }
                }
            }

        });

        //maximum 2 beyond target, none beyond the threshold.
        if (beyondThreshold === 0 && beyondTarget !== 0 && beyondTarget <= 2) {
            state = angular.copy(stateDefinition['orange']);
        } else {

            if (beyondThreshold > 0 || beyondTarget > 2) {
                state = angular.copy(stateDefinition['red']);
            }
        }

        state.tooltip = tooltip;
        return state;
    };

    /**
     * returns a list of slas that have not reached their target
     * @param trainSlaValue
     * @returns {{missedSlaTargets: Array, everythingOk: boolean}}
     */
    factory.getMissedSQIs = function (trainSlaValue) {

        var missedSlaTargets = [];

        var outcome = {
            missedSlaTargets: missedSlaTargets,
            everythingOk: missedSlaTargets.length === 0
        };

        if (arrayUtil.isEmpty(trainSlaValue.slaResults)) {
            return outcome;
        }

        trainSlaValue.slaResults.forEach(function (slaResult) {

            var failedToReach = false;
            if (slaResult.inverted) {
                if (slaResult.value > slaResult.target) {
                    failedToReach = true;
                }
            } else {
                if (slaResult.value < slaResult.target) {
                    failedToReach = true;
                }
            }

            if (failedToReach) {
                missedSlaTargets.push({
                    legend: slaResult.name,
                    value: slaResult.value,
                    unit: slaResult.unit
                });
            }
        });

        outcome.everythingOk = missedSlaTargets.length === 0;
        return outcome;
    };

    return factory;
}];